// 共用「讀取中…」 — 給 list page / detail page / panel 用, 取代各處 inline
// `<div className="text-sm text-slate-400">讀取中…</div>` 的隨機 padding 寫法
// (S3 stress-audit 2026-05-10)。
//
// 用法: <LoadingPlaceholder />  → 預設居中 + p-6
//      <LoadingPlaceholder inline /> → 不要 padding (給已經有 wrapper 的場景)

interface Props {
  /** 不要 padding / center, 給包在現有 wrapper 內的場景用 */
  inline?: boolean;
  /** 自訂文字 (預設「讀取中…」) */
  text?: string;
}

export function LoadingPlaceholder({ inline = false, text = '讀取中…' }: Props) {
  if (inline) {
    return <span className="text-sm text-slate-400">{text}</span>;
  }
  return <div className="p-6 text-sm text-slate-400 text-center">{text}</div>;
}
